module.exports = __webpack_public_path__ + "static/img/step3.4efc867.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mb/mb037/step3.gif
// module id = BrsZ
// module chunks = 0